<template>
  <modal-card ref="modal">
    <h2 class="title is-4">Reject Application</h2>
    <h6 class="subtitle is-6">You are about to approve this application</h6>
    <b-checkbox v-model="checkbox">Send rejection email to the applications</b-checkbox>
    <div class="columns">
      <div class="column">
        <div class="buttons">
        <button class="button is-danger " @click="handleReject()">
          Reject Applicant
        </button>
        <button class="button" type="button" @click="closeModal()">Close</button>
      </div>
      </div>
    </div>
  </modal-card>
</template>

<script>

import ModalCard from '../ModalCard.vue'
import { rejectApplicationMutation } from '../../graphql/applications'
export default {
  name: 'Applicant',
  components: {
    ModalCard
  },
  data () {
    return {
      checkbox: true
    }
  },
  props: {
    applicant: Object
  },
  methods: {
    handleReject () {
      this.$apollo.mutate({
        mutation: rejectApplicationMutation,
        variables: {
          id: this.applicant.id,
          suppressEmail: this.checkbox
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Application Rejected',
            type: 'is-success'
          })
          // redirect back to the applications page
          this.$router.push({ name: 'applications' })
          // close modal
          this.closeModal()
        })
        .catch((e) => {
          this.$toast.open({
            message: 'Failed to Reject!<br>' + (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
          // close modal
          this.closeModal()
        })
    },
    closeModal () {
      // close modal
      this.$refs.modal.close()
      // reset the form
      this.checkbox = true
    }
  }
}
</script>
